import PageHandlers from '@diziner/PageHandlers';
import DOM from '@diziner/Utils/DOM';
import Logger from '@diziner/Logger';
export class IssuePage {
    constructor(pageId) {
        this._body = '';
        this._order = 0;
        this._loaded = false;
        this._name = '';
        this._meta = {
            description: null,
        };
        this._shown = false;
        this._pageId = pageId;
    }
    get pageId() {
        return this._pageId;
    }
    set pageId(value) {
        this._pageId = value;
    }
    get body() {
        return this._body;
    }
    set body(value) {
        this._body = value;
    }
    get order() {
        return this._order;
    }
    set order(value) {
        this._order = value;
    }
    get loaded() {
        return this._loaded;
    }
    set loaded(value) {
        this._loaded = value;
    }
    get name() {
        return this._name;
    }
    set name(value) {
        this._name = value;
    }
    get meta() {
        return this._meta;
    }
    set meta(value) {
        this._meta = value;
    }
    get shown() {
        return this._shown;
    }
    set shown(value) {
        this._shown = value;
    }
    get pageHandlers() {
        return this._pageHandlers;
    }
    set pageHandlers(value) {
        this._pageHandlers = value;
    }
    /**
     * Returns true if this page requires any form of authentication
     * @todo Implement function
     */
    requiresAuthentication() {
        return false;
    }
    findHtmlContainer() {
        if (typeof this._container === 'undefined') {
            this._container = document.querySelector('div.page-container[data-pageid="' + this.pageId + '"]');
        }
        return this._container;
    }
    getPageTitle() {
        if (typeof this._title === 'undefined') {
            this._title = this.findHtmlContainer()?.
                getAttribute('data-pagetitle') ?? '';
        }
        return this._title;
    }
    registerPageHandlers() {
        if (typeof this._pageHandlers === 'undefined') {
            this._pageHandlers = new PageHandlers(this);
        }
        this._pageHandlers.register();
        // @todo Set gfrom target to page url (inline)
    }
    async scrollToTop() {
        this._container?.scroll({ top: 0, behavior: 'smooth' });
    }
    async scrollToBottom() {
        if (!this._container) {
            return;
        }
        this._container.scroll({
            top: (this._container.scrollHeight - this._container.clientHeight),
            behavior: 'smooth',
        });
    }
    async scrollTo(selector, position = 'top') {
        let element = null;
        if (selector.substring(0, 1) === '#') {
            element = document.getElementById(selector.replace('#', ''));
        }
        else {
            element = this._container.querySelector(selector);
        }
        Logger.instance.debug('scrollTo first element:');
        Logger.instance.debug(element);
        if (element === null) {
            // If no direct ID, lets search for data-id's, sections for example.
            element = this._container.querySelector('[data-id="' + selector.replace('#', '') + '"]');
            Logger.instance.debug('scrollTo second element:');
            Logger.instance.debug(element);
        }
        return new Promise((resolve, reject) => {
            if (element === null) {
                reject('Element with selector: "' + selector + '" not found');
                return;
            }
            const rect = element.getBoundingClientRect();
            Logger.instance.debug('Scrolling to element: ');
            Logger.instance.debug(element);
            let scrollOffset = rect.top + this._container.scrollTop;
            if (position === 'center') {
                scrollOffset -= Math.min((rect.height / 2), (window.innerHeight / 2));
            }
            setTimeout(resolve, 700);
            this._container.scrollTo({ top: scrollOffset, behavior: 'smooth' });
            resolve();
        });
    }
    getTopSectionForElement(currentElement) {
        return DOM.queryFurthestElement(currentElement, '.elementor-top-section');
    }
    async scrollToPreviousSection(curElem) {
        return new Promise((resolve, reject) => {
            const furthest = this.getTopSectionForElement(curElem);
            if (furthest) {
                const sectionId = DOM.queryPreviousSibling(furthest, '.elementor-top-section')?.
                    getAttribute('data-id');
                if (sectionId === null) {
                    Logger.instance.warning('Target section has no data-id');
                    reject('Target section has no data-id');
                    return;
                }
                this.scrollTo('[data-id="' + sectionId + '"]');
                resolve();
            }
            reject('No furthest found');
        });
    }
    async scrollToNextSection(curElem) {
        return new Promise((resolve, reject) => {
            const furthest = this.getTopSectionForElement(curElem);
            if (furthest) {
                const sectionId = DOM.queryNextSibling(furthest, '.elementor-top-section')?.
                    getAttribute('data-id');
                if (sectionId === null) {
                    Logger.instance.warning('Target section has no data-id');
                    reject('Target section has no data-id');
                    return;
                }
                this.scrollTo('[data-id="' + sectionId + '"]');
                resolve();
            }
            reject('No furthest found');
        });
    }
}
export default IssuePage;
